import { render, staticRenderFns } from "./RFCField.vue?vue&type=template&id=0dc7aa58"
import script from "./RFCField.vue?vue&type=script&lang=js"
export * from "./RFCField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports